import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { useEffect } from "react";

import classes from "./OrganizationStatusModal.module.css";

const OrganizationStatusModal = ({ isOpen, isSubmitting, mode, onCancel, onConfirm }) => {
	const isDeactivate = mode === "deactivate";

	useEffect(() => {
		if (!isOpen) return undefined;

		const onKeyDown = (event) => {
			if (event.key === "Escape" && !isSubmitting) onCancel();
		};

		document.addEventListener("keydown", onKeyDown);
		document.body.style.overflow = "hidden";

		return () => {
			document.removeEventListener("keydown", onKeyDown);
			document.body.style.overflow = "";
		};
	}, [isOpen, isSubmitting, onCancel]);

	if (!isOpen) return null;

	return (
		<button
			aria-label="Close organization status confirmation"
			className={classes.backdrop}
			onClick={() => !isSubmitting && onCancel()}
			type="button">
			<div
				aria-labelledby="organization-status-modal-title"
				aria-modal="true"
				className={classes.modal}
				onClick={(event) => event.stopPropagation()}
				role="dialog">
				<div
					className={`${classes.iconWrap} ${isDeactivate ? "" : classes.iconWrapActivate}`}
					aria-hidden="true">
					{isDeactivate ? <AlertTriangle size={24} strokeWidth={2} /> : <CheckCircle2 size={24} strokeWidth={2} />}
				</div>

				<h2 className={classes.title} id="organization-status-modal-title">
					{isDeactivate ? "Deactivate Organization" : "Activate Organization"}
				</h2>

				<p className={classes.message}>
					{isDeactivate
						? "Deactivating this organization will immediately remove access for all organization users."
						: "Activating this organization will restore platform access for organization users."}
				</p>

				<div className={classes.actions}>
					<button className={classes.cancelButton} disabled={isSubmitting} onClick={onCancel} type="button">
						Cancel
					</button>
					<button
						className={`${classes.confirmButton} ${isDeactivate ? "" : classes.confirmButtonActivate}`}
						disabled={isSubmitting}
						onClick={onConfirm}
						type="button">
						{isSubmitting ? "Saving..." : isDeactivate ? "Deactivate" : "Activate"}
					</button>
				</div>
			</div>
		</button>
	);
};

export default OrganizationStatusModal;
